import styled from 'styled-components';
import { AppBaseSelect } from 'components/atoms/CommonAppComponents/AppSelect/AppBaseSelect/AppBaseSelect';

export const StyledSelect = styled(AppBaseSelect)`
    .ant-select-selector .ant-select-selection-item {
        padding-inline-end: 180px;
    }
`;

export const LabelContainer = styled.span`
    display: flex;
    align-items: center;
    gap: 10px;
`;
